import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionLabel } from "./motion";
import { scrollToSection } from "./Navbar";

const BLOCKS = [
  { name: "Technology", roles: "2,400+ roles", span: "md:col-span-7", img: "https://images.pexels.com/photos/946310/pexels-photo-946310.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { name: "Finance", roles: "1,100+ roles", span: "md:col-span-5", img: "https://images.pexels.com/photos/1313534/pexels-photo-1313534.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { name: "Healthcare", roles: "900+ roles", span: "md:col-span-4", img: "https://images.pexels.com/photos/34381971/pexels-photo-34381971.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { name: "Engineering", roles: "1,500+ roles", span: "md:col-span-4", img: "https://images.pexels.com/photos/1313534/pexels-photo-1313534.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { name: "Marketing", roles: "700+ roles", span: "md:col-span-4", img: "https://images.unsplash.com/photo-1517048676732-d65bc937f952?crop=entropy&cs=srgb&fm=jpg&q=85" },
];

const EXTRA = ["Retail", "Legal"];

export default function Industries({ onSelectIndustry }) {
  const pick = (name) => {
    onSelectIndustry(name);
    scrollToSection("jobs");
  };

  return (
    <section id="industries" className="bg-[#0A1128] text-white py-24 md:py-32 px-6 md:px-12 lg:px-24" data-testid="industries-section">
      <SectionLabel number="03" text="Industries We Serve" dark />
      <div className="flex flex-col lg:flex-row justify-between lg:items-end gap-6 mb-16">
        <Reveal>
          <h2 className="font-display font-bold text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.02]">
            Deep networks.<br /><span className="text-outline">Every sector.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="text-white/50 font-light max-w-sm leading-relaxed">
            Specialist recruiters who speak the language of your industry — not generalists reading from a script.
          </p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-4">
        {BLOCKS.map((b, i) => (
          <Reveal key={b.name} delay={i * 0.08} className={`${b.span} col-span-1`}>
            <button
              onClick={() => pick(b.name)}
              className="group relative w-full h-64 md:h-72 overflow-hidden text-left"
              data-testid={`industry-block-${b.name.toLowerCase()}`}
            >
              <img
                src={b.img}
                alt={b.name}
                className="absolute inset-0 w-full h-full object-cover opacity-50 group-hover:opacity-70 group-hover:scale-105 transition-all duration-700"
              />
              <div className="absolute inset-0 bg-[#0A1128]/40 group-hover:bg-[#0A1128]/20 transition-colors duration-700" />
              <div className="absolute bottom-0 left-0 right-0 p-8 flex items-end justify-between">
                <div>
                  <h3 className="font-display font-bold text-3xl tracking-tight">{b.name}</h3>
                  <p className="text-white/60 text-xs uppercase tracking-[0.2em] mt-2">{b.roles}</p>
                </div>
                <ArrowUpRight className="text-white/50 group-hover:text-white group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-300" size={28} />
              </div>
            </button>
          </Reveal>
        ))}
        {EXTRA.map((name, i) => (
          <Reveal key={name} delay={0.4 + i * 0.08} className="md:col-span-6 col-span-1">
            <button
              onClick={() => pick(name)}
              className="group w-full border border-white/15 hover:border-[#1D4ED8] p-8 flex items-center justify-between transition-colors duration-300"
              data-testid={`industry-block-${name.toLowerCase()}`}
            >
              <div className="text-left">
                <h3 className="font-display font-bold text-2xl tracking-tight">{name}</h3>
                <p className="text-white/50 text-xs uppercase tracking-[0.2em] mt-1">Explore roles</p>
              </div>
              <ArrowUpRight className="text-white/40 group-hover:text-[#1D4ED8] group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-300" size={24} />
            </button>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
